/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetDepartmentTitlesResponseBody = {
    properties: {
        titles: {
    type: 'array',
    contains: {
        type: 'DepartmentTitle',
    },
    isRequired: true,
},
    },
};